import { workflowApi } from './workflowApiBase';
import { Workflow, WorkflowListItem, GetWorkflowsRequest, DimensionItem } from './types';
import { WorkflowInstanceView } from './instanceTypes';

export const workflowQueriesApi = workflowApi.injectEndpoints({
  endpoints: (builder) => ({
    // ── Workflow queries ──────────────────────────────────────────
    getWorkflows: builder.query<WorkflowListItem[], GetWorkflowsRequest | void>({
      query: (params) => {
        const queryParams = params || {};
        return {
          url: 'workflows',
          params: {
            triggerType: queryParams.triggerType,
            isActive: queryParams.isActive,
            pageNumber: queryParams.pageNumber || 1,
            pageSize: queryParams.pageSize || 50,
          },
        };
      },
      providesTags: ['WorkflowList'],
    }),

    getWorkflow: builder.query<Workflow, string>({
      query: (id) => ({
        url: 'workflows/details',
        params: { id },
      }),
      providesTags: (_result, _error, id) => [{ type: 'Workflow', id }],
    }),

    // ── Instance queries ──────────────────────────────────────────
    getInstancesByEntity: builder.query<WorkflowInstanceView[], string>({
      query: (entityId) => ({
        url: 'workflows/instances/by-entity',
        params: { entityId },
      }),
    }),

    getApprovalStatusBatch: builder.mutation<Record<string, string>, string[]>({
      query: (entityIds) => ({
        url: 'workflows/approval-status-batch',
        method: 'POST',
        body: { entityIds },
      }),
    }),

    // ── Dimension queries ─────────────────────────────────────────
    getWorkflowTriggers: builder.query<DimensionItem[], void>({
      query: () => 'dimensions/workflow-triggers',
      providesTags: ['WorkflowDimensions'],
    }),
    getConditionOperators: builder.query<DimensionItem[], void>({
      query: () => 'dimensions/condition-operators',
      providesTags: ['WorkflowDimensions'],
    }),
    getLogicalOperators: builder.query<DimensionItem[], void>({
      query: () => 'dimensions/logical-operators',
      providesTags: ['WorkflowDimensions'],
    }),
    getStepStatuses: builder.query<DimensionItem[], void>({
      query: () => 'dimensions/step-statuses',
      providesTags: ['WorkflowDimensions'],
    }),
    getAssignmentRuleTypes: builder.query<DimensionItem[], void>({
      query: () => 'dimensions/assignment-rule-types',
      providesTags: ['WorkflowDimensions'],
    }),
    getTicketFields: builder.query<DimensionItem[], void>({
      query: () => 'dimensions/ticket-fields',
      providesTags: ['WorkflowDimensions'],
    }),
  }),
});

export const {
  useGetWorkflowsQuery,
  useGetWorkflowQuery,
  useGetWorkflowTriggersQuery,
  useGetConditionOperatorsQuery,
  useGetLogicalOperatorsQuery,
  useGetStepStatusesQuery,
  useGetAssignmentRuleTypesQuery,
  useGetTicketFieldsQuery,
  useGetInstancesByEntityQuery,
  useGetApprovalStatusBatchMutation,
} = workflowQueriesApi;
